import { Info } from 'lucide-react';

const CPM_RATE_NOTE =
    'Posts earn the CPM rate while there is budget remaining. If the budget runs out, they could earn less.';
const CPM_RATE_NOTE_TIP = 'Post early for the best chance!';

const CpmRateNote = () => (
    <p className="cpm-rate-note">
        <Info className="cpm-rate-note__icon" size={12} aria-hidden="true" />
        <span>
            {CPM_RATE_NOTE}
            <br />
            <br />
            {CPM_RATE_NOTE_TIP}
        </span>
    </p>
);

export default CpmRateNote;
